<template>
  <div>


    <header class="header">
      <div :class="[{ white: istab }, 'banxin']">
        <div class="topbox">
          <a class="logo" href="./"></a>
          <ul class="tablist">
            <li @click="tabclick(1)" :class="num == 1 ? 'active' : ''"> <span>首页</span> </li>
            <!-- <li @click="tabclick(2)" :class="num == 2 ? 'active' : ''"> <span>账户充值</span> </li> -->
            <li @click="tabclick(6)" :class="num == 6 ? 'active' : ''"> <span>主播招募</span> </li>
            <li @click="tabclick(3)" :class="num == 3 ? 'active' : ''"> <span>加入我们</span> </li>
            <li :class="[num == 7 ? 'active' : '', '']">
              <span @click="tabclick(7)" v-if="!islogin">登录</span>
              <div class="delbtn" v-else>
                <el-popover placement="bottom" width="220" :visible-arrow='false' trigger="click">
                  <div class="userinfo">
                    <img class="head" :src="userlist.head" alt="">
                    <div class="riinfo">
                      <p class="name">{{ userlist.name }}</p>
                      <p class="ID">ID：{{ userlist.uid }}</p>
                    </div>

                    <div @click="Logout()" class="Logout">
                      <img class="LogoutIcon" src="../assets/PC/icon-exit-blue-16.png" alt="">
                      <span>退出</span>
                    </div>
                  </div>

                  <el-button class="btn" slot="reference"> <span class="name">{{ userlist.name }}</span> <i
                      class="el-icon-arrow-down"></i></el-button>
                </el-popover>

              </div>

            </li>
            <li @click="tabclick(8)" :class="[num == 8 ? 'active' : '', 'kbbtn']"><button>开播</button> </li>
          </ul>
        </div>
      </div>
      <!-- <div v-if="!istab" class="tast_code">
      </div> -->
    </header>

    <Pclogin :dialogFlag.sync="islogintk"></Pclogin>

  </div>
</template>
<script>
import Pclogin from "./pclogin"
export default {
  components: {
    Pclogin,
  },
  name: 'Header',
  props: {
    istab: {
      type: Boolean,
      default: false
    },
    iskaibo: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      islogintk: false,
      islogin: false,
      visible: false,
      userlist: {},
      num: null,
    }
  },
  watch: {
    islogintk() {
      if (localStorage.getItem("userinfo")) {
        this.userlist = JSON.parse(localStorage.getItem("userinfo"));
        this.islogin = true

      } else {
        this.islogin = false
      }
    }
  },
  created() {
    console.log(6766)
    console.log(this.istab)
    // this.play();
    setTimeout(() => {
      this.num = sessionStorage.getItem("toptab")
      console.log(999)
      console.log(sessionStorage.getItem("toptab"))
    }, 200)

    if (localStorage.getItem("userinfo")) {
      this.userlist = JSON.parse(localStorage.getItem("userinfo"));
      this.islogin = true
      console.log(this.userlist)
    } else {
      this.islogin = false
    }


  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.goPageBefore, false);

    }

  },
  destroyed() {
    window.removeEventListener('popstate', this.goPageBefore, false);
  },
  methods: {
    Logout() { // 退出登录
      if (this.iskaibo) {
        this.$message({ message: '您还在开播，请关闭直播后在退出登录！', type: 'success' });
        return
      }
      localStorage.removeItem("userinfo")
      sessionStorage.removeItem("liveinfo")
      sessionStorage.removeItem("ImInfo")
      this.userlist = {}
      this.islogin = false
      this.$router.push({ path: '/pchome' })

    },
    tabclick(num) {

      console.log(this.num)
      this.beforNum = this.num;
      if (num == 1) {
        this.$router.push({ path: '/pchome' })
      }
      else if (num == 2) {
        this.$router.push({ path: '/recharge' })
      }
      else if (num == 3) {
        this.$router.push({ path: '/joinus' })
      }
      else if (num == 6) {
        this.$router.push({ path: '/pcenlist' })
      }

      else if (num == 7) {
        this.islogintk = true
      }
      else if (num == 8) {
        if (this.islogin) {
          this.$router.push({ path: '/nnlive' })
        } else {
          this.islogintk = true
        }

      }
      sessionStorage.setItem("toptab", num);
    },
    goPageBefore() {
      this.$router.push({ path: '/pchome' })
      this.num = 1;
      sessionStorage.setItem("toptab", '1');
    }

  },
}
</script>
<style lang="less" scoped>
.tast_code {
  background: url('../assets/images2/web/toast-code.png');
  background-size: 100% 100%;
  position: fixed;
  right: 0;
  top: 1.6rem;
  width: 0.9rem;
  height: 1.15rem;
}

.header {
  width: 100%;
  background: rgba(255, 255, 255, .0);
}

.topbox {

  display: flex;
  justify-content: space-between;
  height: .51rem;
  align-items: center;

  .logo {
    background: url('https://resource.imbeiyu.com/nnxqGw/img/pic-logo4.png');
    background-size: 100% 100%;
    width: 1.15rem;
    height: .25rem;
  }

  .tablist {
    width: 3.6rem;
    display: flex;
    margin-right: 0.1rem;
    justify-content: space-between;

    .kbbtn {
      button {
        height: 0.2rem;
        width: 0.5rem;
        background: rgba(69, 148, 255, 1);
        color: #fff;
        font-weight: 600;
        font-family: PingFangSC-Medium, PingFang SC;
        border-radius: .2rem;
        font-size: .08rem;
      }

      button:hover {
        opacity: .9;
      }

    }

    .delbtn {
      width: 100%;
      display: flex;
      padding: 0 .05rem;
      box-sizing: border-box;

      span {
        width: 100%;
      }

      .btn {
        width: 100%;
        padding: 0;
        background: rgba(255, 255, 255, 0);
        font-weight: 600;
        color: #333333;
        font-family: PingFangSC-Medium, PingFang SC;
        font-size: .08rem;
      }

      .name {
        width: 60%;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

    }

    li {
      height: .1rem;
      justify-content: center;
      display: flex;
      align-items: center;
      width: 25%;
      line-height: .08rem;
      width: 25%;
      text-align: center;
      border-left: 1Px solid rgba(169, 169, 169, 0.5);
      cursor: pointer;

    }

    li:last-child {
      border-left: none;
    }

    li:first-child {
      border-left: none;
    }

    li span {
      font-weight: 600;
      color: #333333;
      font-family: PingFangSC-Medium, PingFang SC;
      font-size: .08rem;
    }

    li:hover {
      position: relative;

      span {
        color: #1C74F2;
      }

      span::after {
        content: '';
        position: absolute;
        width: 10%;
        height: .01rem;
        bottom: -.04rem;
        left: 50%;
        transform: translateX(-50%);
        background: #1C74F2;
      }
    }

    .active {
      position: relative;

      span {
        color: #1C74F2;
      }

      span::after {

        content: '';
        position: absolute;
        width: 10%;
        height: .01rem;
        bottom: -.04rem;
        left: 50%;
        transform: translateX(-50%);
        background: #1C74F2;
      }
    }
  }
}

.white {

  .topbox {
    .delbtn {
      .btn {
        color: #fff;
      }

    }

    .kbbtn {
      button {

        background: #fff;
        color: rgba(69, 148, 255, 1);

      }
    }

    li {
      border-left: 1Px solid rgba(255, 255, 255, .6);

    }

    .logo {
      background: url('../assets/PC/pic-logo1.png');
      background-size: 100% 100%;
      width: 1.15rem;
      height: .25rem;
    }

    li span {
      color: #fff;
    }

    li:hover {
      position: relative;

      span {
        color: rgba(255, 255, 255, 1);
      }

      span::after {

        content: '';
        position: absolute;
        width: 10%;
        height: .01rem;
        bottom: -.04rem;
        left: 50%;
        transform: translateX(-50%);
        background: rgba(255, 255, 255, 1);
      }
    }

    .active {
      position: relative;

      span {
        color: rgba(255, 255, 255, 1);
      }

      span::after {

        content: '';
        position: absolute;
        width: 10%;
        height: .01rem;
        bottom: -.04rem;
        left: 50%;
        transform: translateX(-50%);
        background: rgba(255, 255, 255, 1);
      }
    }

  }

}

.userinfo {
  width: 100%;
  height: 24%;
  border-radius: 4Px;
  display: flex;
  align-items: center;

  .head {
    margin-left: .0rem;
    width: .35rem;
    height: .35rem;
    border-radius: 50%;
  }

  .riinfo {
    width: .6rem;
    margin-left: .04rem;
    display: flex;
    flex-direction: column;
    height: .35rem;
    justify-content: center;
    color: rgba(31, 45, 61, 1);
    font-size: .1rem;

    .name {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

  }

  .ID {
    margin-top: .03rem;
    color: rgba(153, 169, 191, 1);
    font-size: .09rem;
  }

  .Logout {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: .1rem;
    margin-left: .2rem;
    color: rgba(69, 148, 255, 1);

    .LogoutIcon {

      width: auto;
      height: .1rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue